import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import './index.less';
import { ReactComponent as Paid } from '@/assets/icons/paid.svg';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@/redux/action';
import { requsetGetSubscription } from '@/api/apis';
import sentGAEvent from '@/ga';
import Utils from '@/utils/index.js';
import { useTranslation } from 'react-i18next';

const PayBill = () => {
  const reducerData = useSelector((state) => state.common);
  const work = useSelector((state) => state.work);
  const { t } = useTranslation(['common']);

  const dispatch = useDispatch();
  const { payBill, payTrigger, purchaseModalObj, subscription } = reducerData;
  

  const onPayment = () => {
    let sku;
    if (work.work === 'dynamicPhoto') {
      sku = reducerData.sku;
    } else {
      if (reducerData.skSwitchOther === 'yearly') {
        sku = 'Yearly';
      } else if (reducerData.skSwitchOther === 'Monthly') {
        sku = 'Monthly';
      }
    }

    let gaWork = work.work;
    let proGa = true;
    if (work.work === 'addLipShape') {
      gaWork = 'FaceAnimator';
    } else if (work.work === 'audioExtractor') {
      gaWork = 'AudioExtractor';
    } else if (work.work === 'convert') {
      gaWork = 'VideoConverter';
    } else if (work.work === 'dynamicPhoto') {
      gaWork = 'AnimateOld';
    } else if (work.work === 'audioCut') {
      gaWork = 'audioCut';
    } else if (work.work === 'togif') {
      gaWork = 'togif';
    } else if (work.work === 'audioJoiner') {
      gaWork = 'audioJoiner';
    } else {
      // 非上面几个产品不走GA
      proGa = false;
    }
    console.log(sku, Utils.systemCheck(), purchaseModalObj.trigger, work.work);

    dispatch(actions.onPayBill(false));
    // 执行单次检查操作,此处重新写是因为hook不能调用class类型组件方法，因为内部有this.props
    requsetGetSubscription({
      from_product: work.work === 'screenRecorder' ? 11 : 1,
    })
      .then((res) => {
        const { subscription } = res.data;
        console.log(res.data);
        if (subscription == null) {
          // 没有数据
          sentGAEvent({
            category: 'OrderStatus',
            action: 'OrderFail',
            label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
              purchaseModalObj.trigger
            }`}_OLPro_${sku}_${Utils.systemCheck()}`,
          });
        } else {
          let subArr;

          subArr = subscription.filter((item) => {
            return item.product_name === 'HitPaw Online';
          });
          console.log(subArr);

          let isSubscriber = false;
          if (subArr.length > 0 && subArr[0].status === 'Active') {
            isSubscriber = true;
          } else {
            isSubscriber = false;
          }
          const subscribeStatus = isSubscriber ? 'Active' : 'Expired';
          const subscribeTime = subArr[0]?.active_Time || undefined;

          if (proGa) {
            payCheck(subscription, gaWork);
          }
          // 改数据
          dispatch(actions.onSubscriptionChange(res.data.subscription));
          let hasAccount = document.querySelectorAll('.has-account');
          // 改icon
          if (subscription && subscription[0].status === 'Active') {
            hasAccount.forEach(function (elem) {
              elem.querySelector('.vip').classList.replace('d-none', 'd-flex');
              elem.querySelector('.user').classList.replace('d-flex', 'd-none');
            });
            let upGradeBtns = document.querySelectorAll('.account-upgrade');
            if (upGradeBtns && upGradeBtns.length) {
              upGradeBtns.forEach(function (elem) {
                elem.style = 'display: none !important';
              });
            }
          } else {
            hasAccount.forEach(function (elem) {
              elem.querySelector('.vip').classList.replace('d-flex', 'd-none');
              elem.querySelector('.user').classList.replace('d-none', 'd-flex');
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const payCheck = (newSubscription, gaWork) => {
    console.log('sdjlkfsdlkfj', newSubscription);

    let sku;
    if (work.work === 'dynamicPhoto') {
      sku = reducerData.sku;
    } else {
      if (reducerData.skSwitchOther === 'yearly') {
        sku = 'Yearly';
      } else if (reducerData.skSwitchOther === 'Monthly') {
        sku = 'Monthly';
      }
    }
    let subscribeStatus = subscription[0].status; //本地状态
    let subscribeTime = subscription[0].active_Time; //本地有效期

    // 情况1
    if (!newSubscription) {
      // payFail(true);
      // 没有订阅
      sentGAEvent({
        category: 'OrderStatus',
        action: 'OrderFail',
        label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
          purchaseModalObj.trigger
        }`}_OLPro_${sku}_${Utils.systemCheck()}`,
      });
    } else {
      let { status, active_Time } = newSubscription[0];
      console.log(
        'qqqqqqqqqqqqqqqqqqqqqqqqqq',
        subscribeStatus,
        status,
        active_Time,
        subscribeTime
      );
      // 情况2
      if (subscribeStatus === '' && status === 'Active') {
        // paySuccess();
        sentGAEvent({
          category: 'OrderStatus',
          action: 'OrderSuccess',
          label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
            purchaseModalObj.trigger
          }`}_OLPro_${sku}_${Utils.systemCheck()}`,
        });
      }

      if (status === 'Expired') {
        if (subscribeStatus === 'Active' || subscribeStatus === 'Expired') {
          //退订
          // payFail();
          sentGAEvent({
            category: 'OrderStatus',
            action: 'OrderFail',
            label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
              purchaseModalObj.trigger
            }`}_OLPro_${sku}_${Utils.systemCheck()}`,
          });
        }
      }

      // 情况4
      if (subscribeStatus === 'Active' && status === 'Active') {
        if (subscribeTime === active_Time) {
          // 未续费
          // payFail();
          sentGAEvent({
            category: 'OrderStatus',
            action: 'OrderFail',
            label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
              purchaseModalObj.trigger
            }`}_OLPro_${sku}_${Utils.systemCheck()}`,
          });
        } else {
          // 续费
          if (computeTime(active_Time, subscribeTime)) {
            // paySuccess();
            sentGAEvent({
              category: 'OrderStatus',
              action: 'OrderSuccess',
              label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
                purchaseModalObj.trigger
              }`}_OLPro_${sku}_${Utils.systemCheck()}`,
            });
          } else {
            // payFail();
            sentGAEvent({
              category: 'OrderStatus',
              action: 'OrderFail',
              label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
                purchaseModalObj.trigger
              }`}_OLPro_${sku}_${Utils.systemCheck()}`,
            });
          }
        }
      }

      // 情况5
      if (subscribeStatus === 'Expired' && status === 'Active') {
        // paySuccess();
        sentGAEvent({
          category: 'OrderStatus',
          action: 'OrderSuccess',
          label: `${gaWork || 'NULL'}_${`${gaWork || 'NULL'}${
            purchaseModalObj.trigger
          }`}_OLPro_${sku}_${Utils.systemCheck()}`,
        });
      }
      // 当会员有效期发生变化或者会员过期时，更新存储状态
      // if (
      //   subscribeTime !== active_Time ||
      //   (subscribeStatus === 'Active' && status === 'Expired')
      // ) {
      //   // newStatusStore(subscription);
      //   Cookies.set('subscribeStatus', status)
      //   Cookies.set('subscribeTime', active_Time)
      // }
    }
  };
  const computeTime = (subTime, nowTime) => {
    let time1 = new Date(subTime.substring(11, subTime.length)).getTime();
    let time2 = new Date(nowTime.substring(11, nowTime.length)).getTime();
    if (time1 - time2 > 0) {
      //如果订阅时间大于本地存的时间，说明续费，否则退订
      return true;
    } else {
      return false;
    }
  };

  return (
    <Modal
      className='payBill'
      centered
      footer={null}
      visible={payBill}
      closable={false}
      maskClosable={false}
    >
      <div>
        <div className='billTitle'>{t('Your order is being paid...')}</div>
        <div className='billIcon'>
          <Paid />
        </div>
        <div className='bottomBtn'>
          <div onClick={() => onPayment()} className='notYet'>
            {t('Not yet')}
          </div>
          <div onClick={() => onPayment()} className='complete'>
            {t('Payment completed')}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PayBill;
